import { FC, memo, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsOnline } from "@/hooks/useIsOnline";
import { call } from "@/services/call";
import { Button, Spinner } from "@/ui";
import { StyledReconnecting } from "./styled";

const Reconnecting: FC = () => {
  const {t} = useTranslation();
  const isOnline = useIsOnline();
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    call.onReconnecting(() => {
      setIsReconnecting(true);
    });
    call.onReconnected(() => {
      setIsReconnecting(false);
    });
  }, []);

  const text = useMemo(() => {
    if (!isOnline) {
      return {
        title: t('no_internet_connection'),
        message: t('check_network_settings'),
      };
    }

    if (isReconnecting) {
      return {
        title: t('reconnecting'),
        message: t('reconnecting_message'),
      };
    }

    return null;
  }, [isReconnecting, isOnline, t]);

  const onTryAgain = () => {
    window.location.reload();
  };

  if (!isReconnecting && isOnline) {
    return null;
  }

  return (
    <StyledReconnecting>
      {isOnline && <Spinner />}
      <h3>{text?.title}</h3>
      <p>{text?.message}</p>
      {!isOnline && (
        <Button onClick={onTryAgain} variant="secondary">{t('try_again')}</Button>
      )}
    </StyledReconnecting>
  );
};

export default memo(Reconnecting);